module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/01-e7bf312b7ab0b8bff6ba646cf88ad3c1.jpg";